/**
* @desc 用来获取和设置sessionStorage存储
**/
let session = {
  save (key = '', value = '') {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  fetch (key = null) {
      return JSON.parse(sessionStorage.getItem(key) || null) || ''
  },
  clear(){
    sessionStorage.clear()
  },
  keys(){
    return sessionStorage.keys()
  },
  removeItem (key = '') {
    return sessionStorage.removeItem(key)
  }
}

export default session
